import { previewSharePointDocumentLinkInSxS } from '../../actions/publicActions';
import { closeLinkContextMenu } from '../../components/LinkContextMenu';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';
import getWacInfoForSharePointLink from 'owa-attachment-wac/lib/utils/getWacInfoForSharePointLink';
import strings from 'owa-strings/owa-mail-strings';

export function getLinkPreviewContextMenuItem(linkUrl: string): IContextualMenuItem {
    return {
        name: strings.PreviewText,
        key: 'Preview',
        onClick: () => {
            previewLinkInSxS(linkUrl);
            closeLinkContextMenu();
        },
    };
}

function previewLinkInSxS(linkUrl: string) {
    previewSharePointDocumentLinkInSxS(async () => {
        return await getWacInfoForSharePointLink(linkUrl);
    });
}
